export enum NoteEmailEventTypesEnum {
  ADDED = 'Added',
  UPDATED = 'Updated',
  DELETED = 'Deleted',
  LOAD = 'Load',
  SENT = 'Sent',
}
